import styled from "styled-components";
import {
  Container,
  SectionHeader,
  Subtitle,
  Title,
  Description,
} from "./Section";

const GallerySection = styled.section`
  padding: 120px 24px;
  background: linear-gradient(180deg, #f5f2ed 0%, #faf8f5 100%);

  @media (max-width: 768px) {
    padding: 80px 24px;
  }
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const GalleryItem = styled.div`
  background-image: ${(props) =>
    props.$image ? `url(${props.$image})` : "none"};
  background-color: ${(props) => (!props.$image ? "#e5e1dc" : "transparent")};
  background-size: cover;
  background-position: center;
  aspect-ratio: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      transparent 40%,
      rgba(26, 26, 26, 0.8) 100%
    );
    opacity: 0.7;
    transition: opacity 0.4s;
  }

  &:nth-child(1) {
    grid-column: span 2;
    grid-row: span 2;

    @media (max-width: 768px) {
      grid-column: span 1;
      grid-row: span 1;
    }
  }

  &:hover {
    transform: scale(1.02);

    &::before {
      opacity: 0.9;
    }
  }
`;

const GalleryLabel = styled.span`
  position: relative;
  z-index: 1;
  padding: 20px;
  font-size: 14px;
  color: #faf8f5;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const Gallery = () => {
  const galleryItems = [
    { label: "Hotel Exterior", image: "/images/hebe2.webp" },
    { label: "Lobby", image: "/images/hebe3.webp" },
    { label: "Deluxe Room", image: "/images/hebe1.webp" },
    { label: "Restaurant", image: null },
    { label: "Pool Area", image: null },
    { label: "Rooftop", image: null },
    { label: "Fitness Center", image: null },
  ];

  return (
    <GallerySection id="gallery">
      <Container>
        <SectionHeader>
          <Subtitle>Gallery</Subtitle>
          <Title>
            Explore Our <strong>Space</strong>
          </Title>
          <Description>
            Get a glimpse of the modern eco-friendly environment we have created
            for you
          </Description>
        </SectionHeader>

        <GalleryGrid>
          {galleryItems.map((item, index) => (
            <GalleryItem key={index} $image={item.image}>
              <GalleryLabel>{item.label}</GalleryLabel>
            </GalleryItem>
          ))}
        </GalleryGrid>
      </Container>
    </GallerySection>
  );
};

export default Gallery;
